import { render, staticRenderFns } from "./project_detail.vue?vue&type=template&id=85b12168&scoped=true"
import script from "./project_detail.vue?vue&type=script&lang=js"
export * from "./project_detail.vue?vue&type=script&lang=js"
import style0 from "./project_detail.vue?vue&type=style&index=0&id=85b12168&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b12168",
  null
  
)

export default component.exports